// Resumen legible de lo que hizo el backend al AGENDAR una demo (respuesta de
// POST /ventas/demos → { sync }). Hermano de rescheduleSummary.js: el usuario debe ver lo
// que el sistema hace por detrás, incluido lo que NO ha podido hacer, para no tener que
// explicárselo cliente a cliente.
//
// Las claves llevan el prefijo "translation:" a propósito: el t() de las páginas que lo
// usan tiene otro namespace por defecto y sin el prefijo saldrían en crudo.
export function buildScheduleSummary(resp, t, kind = "demo") {
  const sync = resp?.sync || {};
  const titleKey = kind === "config"
    ? "translation:demos.scheduleSummary.titleConfig"
    : "translation:demos.scheduleSummary.title";
  const lines = [t(titleKey)];

  if (sync.calendar_rows > 0) {
    lines.push(t("translation:demos.scheduleSummary.calendarBlocked"));
    lines.push(t("translation:demos.scheduleSummary.remindersSet"));
  }
  if (sync.lead_notified !== undefined) {
    lines.push(t(sync.lead_notified
      ? "translation:demos.scheduleSummary.leadNotified"
      : "translation:demos.scheduleSummary.leadNotNotified"));
  }
  if (sync.closer_notified !== undefined) {
    lines.push(t(sync.closer_notified
      ? "translation:demos.scheduleSummary.closerNotified"
      : "translation:demos.scheduleSummary.closerNotNotified"));
  }
  return lines.join("\n");
}
